import React from "react";
import { getStatusCopy } from "./statusCopy";
import "./LoadingView.scss";

export default function LoadingView({
  size = "page",
  variant = "indicator",
  title,
  description
}) {
  const copy = getStatusCopy();
  const skeleton = variant === "hero" || variant === "shelf";

  return (
    <div
      className={`atlas-loading atlas-loading--${size} atlas-loading--${variant}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <span className={skeleton ? "atlas-loading-sr" : "atlas-loading-label"}>
        {title || copy.loadingLabel}
      </span>
      {variant === "hero" && (
        <div className="showcase-hero" aria-hidden="true">
          <div className="atlas-loading-hero-card showcase-center-card">
            <div className="showcase-copy">
              <span className="atlas-loading-block atlas-loading-title" />
              <span className="atlas-loading-block atlas-loading-meta" />
              <div className="showcase-actions">
                <span className="atlas-loading-block atlas-loading-button" />
                <span className="atlas-loading-block atlas-loading-button" />
              </div>
            </div>
          </div>
        </div>
      )}
      {variant === "shelf" && (
        <div className="atlas-loading-shelf" aria-hidden="true">
          <span className="atlas-loading-block atlas-loading-heading" />
          <div className="atlas-loading-cards">
            {Array.from({ length: 7 }, (_, index) => (
              <div className="atlas-loading-card" key={index}>
                <div className="atlas-loading-block atlas-loading-poster" />
                <span className="atlas-loading-block atlas-loading-caption" />
              </div>
            ))}
          </div>
        </div>
      )}
      {!skeleton && (
        <>
          <span className="atlas-loading-track" aria-hidden="true">
            <span />
          </span>
          {description && <p className="atlas-loading-note">{description}</p>}
        </>
      )}
    </div>
  );
}
